import { render, staticRenderFns } from "./jobhunter.vue?vue&type=template&id=21be9ed4&scoped=true"
import script from "./jobhunter.vue?vue&type=script&lang=js"
export * from "./jobhunter.vue?vue&type=script&lang=js"
import style0 from "./jobhunter.vue?vue&type=style&index=0&id=21be9ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be9ed4",
  null
  
)

export default component.exports